export function imageSlider() {
    const $slider = $(".image-slider");
    $slider.each(function (i, el) {
        $(el).slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: false
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/imageSlider.js